/** Return boolean value check whether all element in array are empty */
export function isAllEmpty(array) {
  return array.every(e => !e);
}
